module.exports = __webpack_public_path__ + "img/charge.f2f3d5fc.png";